import { Component, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { TranslationService } from '../../../../services/translation.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { LineupComponent } from '../lineup/lineup.component';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-equipments',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    NzSkeletonComponent,
    LineupComponent,
    NzIconModule,
  ],
  templateUrl: './equipments.component.html',
  styleUrl: './equipments.component.scss',
})
export class EquipmentsComponent {
  @Input() public informationTeam: any;

  urlSVG = environment.urlIcon;
  urlIMG = environment.urlIMG;

  currentLanguage: any = this.translatorService.getCurrentLanguage();

  constructor(private readonly translatorService: TranslationService) {}

  ngOnInit(): void {
    this.informationTeam;
  }
}
